import { useEffect, useState } from 'react';
import { useInView } from 'react-intersection-observer';
import { Props_SnippetContentColumn } from './ContentColumn.props'
import { CompileHeadingToSpan, CompileMarkdown } from '../../../../Shared/AttraxTs/React/ReactSnippetMDCompiler'
import { Swiper, SwiperSlide } from 'swiper/react'
import { Navigation, Pagination } from 'swiper/modules'
import { createNavigationButtonContainer } from '../CarouselsNew';
import SnippetLink from 'Shared/Link/Link';

export const SnippetContentColumn = (props: Props_SnippetContentColumn) => {
    const { snippet, heading, summary, repeatable_entry } = props;
    const classSnippetBackground = `snippet-content-column snippet-content-column--background-${snippet.background.value}`;
    const classCardOptions = `snippet-content-column snippet-content-column--${snippet.cardPerRow.value}`;
    
    const classHeadingVisibility = heading.visibility.value ? 'snippet-content-column__heading' : 'snippet-content-column__heading accessible-heading';
    
    const classCarouselMobile = snippet.carouselMobile.value === 'true' ? 'snippet-content-column--carousel-mobile' : 'snippet-content-column--no-carousel-mobile';
    const classCarouselDesktop = snippet.carouselDesktop.value === 'true' ? 'snippet-content-column--carousel-desktop' : 'snippet-content-column--no-carousel-desktop';

    const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 768);

    const { ref, inView } = useInView({ triggerOnce: true, threshold: 0.2 });

    useEffect(() => {
        const handleResize = () => {
            setIsSmallScreen(window.innerWidth < 768);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const shouldUseSwiper = (snippet.carouselMobile.value === 'true' && isSmallScreen) || 
                            (snippet.carouselDesktop.value === 'true' && !isSmallScreen);

    const slidesPerView = Number(snippet.cardPerRow.value);
    const breakpoints = {
        479: { slidesPerView: 2 },
        991: { slidesPerView: slidesPerView }
    };

    useEffect(() => {
        if (shouldUseSwiper) {
            setTimeout(() => {
                const swiperElement = document.querySelector('.swiper') as any;
                if (swiperElement) {
                    createNavigationButtonContainer(swiperElement.swiper);
                }
            }, 0);
        }
    }, [shouldUseSwiper]);

    return (
        <section 
            ref={ref} 
            className={`${classSnippetBackground} ${classCardOptions} ${classCarouselMobile} ${classCarouselDesktop} snippet-content-column--fade ${inView ? 'is-visible' : ''}`}
        >
            <div className="snippet-content-column__container">
                <div className="snippet-content-column__heading-container">
                    <h2 className={classHeadingVisibility}>{CompileHeadingToSpan(heading.content.value || '')}</h2>
                    {summary?.content?.value && (
                        <div className="snippet-content-column__summary">
                            {CompileMarkdown(summary.content.value)}
                        </div>
                    )}
                </div>

                {shouldUseSwiper ? (
                    <Swiper
                        modules={[Navigation, Pagination]}
                        spaceBetween={24}
                        slidesPerView={1}
                        navigation
                        pagination={{ clickable: true }}
                        watchOverflow={true}
                        autoHeight={false}
                        breakpoints={breakpoints}
                        watchSlidesProgress={true}
                    >
                        {repeatable_entry.map((entry, index) => (
                            <SwiperSlide key={index}>
                                <div className="snippet-content-column__entry">
                                    {entry.image?.value && (
                                        <figure className="snippet-content-column__entry-image-container">
                                            <img
                                                className="snippet-content-column__entry-image"
                                                loading="lazy"
                                                height={270}
                                                width={360}
                                                src={entry.image.value}
                                                alt={entry.alt?.value || ''}
                                            />
                                        </figure>
                                    )}
                                    <div className="snippet-content-column__entry-content-container">
                                        {entry.heading?.value && <h3 className="snippet-content-column__entry-title">{CompileHeadingToSpan(entry.heading.value)}</h3>}
                                        {entry.content?.value && (
                                            <div className="snippet-content-column__entry-content">
                                                {CompileMarkdown(entry.content.value)}
                                            </div>
                                        )}
                                       <SnippetLink
                                    linkStyles={entry.linkStyle?.value}
                                    className="snippet-content-column__entry-link"
                                    url={entry.linkHref?.value}
                                    openInNewTab={entry.linkTarget?.value}
                                >
                                    {entry.linkText?.value}
                                </SnippetLink>
                                    </div>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                ) : (
                    <div className="snippet-content-column__container-entries">
                        {repeatable_entry.map((entry, index) => (
                            <div key={index} className="snippet-content-column__entry">
                                {entry.image?.value && (
                                    <figure className="snippet-content-column__entry-image-container">
                                        <img
                                            className="snippet-content-column__entry-image"
                                            loading="lazy"
                                            height={270}
                                            width={360}
                                            src={entry.image.value}
                                            alt={entry.alt?.value || ''}
                                        />
                                    </figure>
                                )}
                                <div className="snippet-content-column__entry-content-container">
                                    {entry.heading?.value && <div className="snippet-content-column__entry-title">{CompileMarkdown(entry.heading.value)}</div>}
                                    {entry.content?.value && (
                                        <div className="snippet-content-column__entry-content">
                                            {CompileMarkdown(entry.content.value)}
                                        </div>
                                    )}
                                     <SnippetLink
                                    linkStyles={entry.linkStyle?.value}
                                    className="snippet-content-column__entry-link"
                                    url={entry.linkHref?.value}
                                    openInNewTab={entry.linkTarget?.value}
                                >
                                    {entry.linkText?.value}
                                </SnippetLink>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </section>
    );
};
